'use strict';

import Vue from "vue";
import VueRouter from "vue-router";
import firebase from 'firebase/app'
import Main from '@/views/Main'
import Admin from '@/views/Admin'
import Login from '@/views/Login'
import AmlKyc from '@/components/AmlKyc'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Main',
    meta: {auth: false},
    component: Main
  },
  {
    path: '/admin',
    name: 'Admin',
    meta: {auth: true},
    component: Admin
  },
  {
    path: '/login',
    name: 'Login',
    meta: {auth: false},
    component: Login
  },
  {
    path: '/aml-kyc',
    name: 'AmlKyc',
    meta: {auth: false},
    component: AmlKyc
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    if (to.hash) {
      return {
        selector: to.hash
      }
    }

    return { x: 0, y: 0 }
  }
});

router.beforeEach((to, from, next) => {
  const loggedIn = firebase.auth().currentUser
  
  if (to.matched.some(record => record.meta.auth)) {
    if (!loggedIn) {
      next({
        path: '/login'
      })
    } else {
      next()
    } 
  } else {
    next()
  }
})

export default router;
